var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05504 13.9L13.8163 5.1388C14.1775 4.77756 14.6786 4.59221 15.1879 4.63139L21.3162 5.10279C22.1768 5.16899 22.8606 5.85281 22.9268 6.71342L23.3982 12.8417C23.4374 13.351 23.252 13.8521 22.8908 14.2133L14.1296 22.9745C13.4462 23.658 12.3381 23.658 11.6547 22.9745L5.05504 16.3749C4.37163 15.6915 4.37163 14.5834 5.05504 13.9ZM25.1431 12.7075C25.2214 13.7262 24.8507 14.7283 24.1282 15.4508L15.367 24.212C14.0002 25.5788 11.7841 25.5788 10.4173 24.212L3.81761 17.6123C2.45077 16.2455 2.45077 14.0294 3.81761 12.6626L12.5788 3.90136C13.3013 3.17888 14.3034 2.80818 15.3221 2.88654L21.4504 3.35795C23.1716 3.49035 24.5392 4.85797 24.6716 6.5792L25.1431 12.7075Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0167 8.53767C16.3333 9.22109 16.3333 10.3291 17.0167 11.0125C17.7001 11.696 18.8082 11.696 19.4916 11.0125C20.175 10.3291 20.175 9.22109 19.4916 8.53767C18.8082 7.85425 17.7001 7.85425 17.0167 8.53767Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97332 15.756L12.2732 19.0559C12.6149 19.3976 13.1689 19.3976 13.5106 19.0559C13.8523 18.7142 13.8523 18.1602 13.5106 17.8184L10.2108 14.5186C9.86905 14.1769 9.31503 14.1769 8.97332 14.5186C8.63161 14.8603 8.63161 15.4143 8.97332 15.756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.c82e29a35fadb4a9a8331ce1f31bb9d1.svg";
export { ForwardRef as ReactComponent };